export const studioAttrGrpAttrAssocObj = "studioGroupAttributes";
export const studioAttrValAssocObj = "studioAttributeValues";
